// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".invite-rules-root .custom-nav-block{background-color:#f9f9fb}.invite-rules-root .van-nav-bar .van-nav-bar__content .van-nav-bar__left .left-nav{width:.53333rem;height:.53333rem}.invite-rules-root .van-nav-bar .van-nav-bar__content .van-nav-bar__left .tit-left{font-family:Roboto-Regular;font-weight:400;font-size:.53333rem;color:#333}", ""]);
// Exports
module.exports = exports;
